import { Redirect } from 'react-router';
import Logger from '../../toolkit/logger/Logger';
import auth from '../../utils/auth';

const Logout: React.FC = () => {
  Logger.info('Logout::call');
  auth.removeJwt();
  return <Redirect to='/' />
}

export default Logout;
